module.exports = __webpack_public_path__ + "static/media/capaTerciaria.39b142e1.svg";